import ServiceCRUD from '../../../services/ServiceCRUDFLEXUC';

class SectorService extends ServiceCRUD {
  constructor() {
    super('/api/spies');
  }
}

export default new SectorService();
